export default "__VITE_ASSET__BwrdY$Il__"